import React from "react";
import {
  compose,
  withPropsOnChange,
  withStateHandlers,
  branch,
  withHandlers,
} from "recompose";
import { LocalForm, Control, actions } from "react-redux-form";
import { keys } from "lodash";
import { NotificationManager } from "react-notifications";
import {
  Page,
  FormGroup,
  required,
  SaveButton,
  withReload,
} from "components/common";
import { withXeroErrors } from "components";
import { Button, Table } from "reactstrap";
import { Trans } from "react-i18next";
import BackButton from "components/refactoring/BackButton";


export const ContactGroupEdit = ({
  title,
  setState,
  form,
  item,
  onSubmit,
  dispatch,
  errors,
  readOnly,
  XeroErrors,
  handleDelete,
  history,
  ...props
}) => {

  const linkCon = () => {
    history.push(`/contacts`)
  };
  
  return (

  <Page title={title}>
    <div className="mx-2" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <BackButton styleClass="my-2"/>
      <Button color="primary" onClick={linkCon}><span className="fa fa-plus mr-1" /><Trans>Add Contacts</Trans></Button>
    </div>
    <LocalForm
      initialState={item}
      onUpdate={(form) => setState({ form })}
      onChange={(item) => setState({ item })}
      onSubmit={onSubmit}
      getDispatch={(dispatch) => setState({ dispatch })}
      validators={{
        Name: { required },
      }}
    >
      <XeroErrors />
      <FormGroup model=".Name" label="Group Name">
        <Control.text readOnly={readOnly} model=".Name" updateOn="blur" />
      </FormGroup>
      {!readOnly && (
        <SaveButton disabled={false} className="float-right mt-3" form={form} />
      )}
    </LocalForm>
      {item?.Contacts?.length > 0 ? 
        <Table className="border">
        <thead>
          <tr>
            <th className="text-left"><Trans>Contacts</Trans></th>
            <th><Trans>Delete</Trans></th>
          </tr>
        </thead>
        <tbody>
          {item.Contacts.map((contact) => (
            <tr>
              <td className="text-left">{contact.Name}</td>
              <td>
                <Button onClick={() => handleDelete(contact)}color="danger" size="sm" className="btn-icon">
                <span className="fa fa-trash" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      :
      <div className="text-center text-muted"><p style={{fontStyle:"italic"}}><Trans>No Contacts are assigned to this group.</Trans></p></div>
      }
  </Page>
)};

export const enhance = compose(
  withReload(),
  withStateHandlers(
    {},
    {
      setState: () => (state) => ({ ...state }),
    }
  ),
  withPropsOnChange(["match"], ({ xero, match, setState, dispatch, item }) => {
    const { id } = match.params;

    Promise.props({
      item: id === "new" ? {} : xero.get(`contactgroups/${id}`).get("data"),
      readOnly: id !== "new",
      ready: true,
    })
      .then(setState)
      .then(() => {
        if (!dispatch) return;
        // We have the old un-updated value of item
        keys(item).forEach((key) =>
          dispatch(actions.change("local." + key, undefined))
        );
      });
  }),
  branch(
    (props) => !props.ready,
    () => () => null
  ),
  withXeroErrors(),
  withHandlers({
    onSubmit:
      ({
        xero,
        history,
        match,
        dispatch,
        setState,
        t,
        reload,
        setXeroErrors,
      }) =>
      (item) => {
        setXeroErrors(null);

        const p = item.ContactGroupID
          ? xero.put(`contactgroups/${item.ContactGroupID}`, item)
          : xero.post("contactgroups", item);

        return p
          .get("data")
          .tap((data) => {
            NotificationManager.success(t("Saved successfully"));
            history.replace(match.path.replace(":id", data.ContactGroupID));
            reload();
          })
          .catch((err) => {
            dispatch(actions.setPending("local", false));
            setXeroErrors(err);
          });
      },
      handleDelete: 
      ({ client, selectedOrganisation, t, item, reload }) => (contact) => {
        const contacts = [contact.ContactID]; 
        const contact_group = item?.ContactGroupID; 
    
        client.post(`/xero_actions/${selectedOrganisation.id}/remove_contacts_from_group`, { contacts, contact_group })
          .then(response => {
            console.log("Server response:", response.data);
            NotificationManager.success(t(`Successfully removed the Contact - ${contact.Name}`));
            reload();
          })
          .catch(error => {
            console.error("Error:", error);
            NotificationManager.error(t("An error occurred while deleting"));
          });
    },
  })
);

export default enhance(ContactGroupEdit);
